import { createRootRouteWithContext } from '@tanstack/react-router';
import Layout from '@Layout/Layout';
import {
    settingsQueryOptions,
    subscriptionsQueryOptions,
} from '@utils/queryOptions';
import Loading from '@Components/General/Feedback/Loading';
import { QueryClient } from '@tanstack/react-query';

interface RouterContext {
    queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
    component: Layout,
    loader: opts =>
        Promise.all([
            opts.context.queryClient.ensureQueryData(settingsQueryOptions()),
            // opts.context.queryClient.ensureQueryData(
            //     subscriptionsQueryOptions(),
            // ),
            // new Promise(resolve => setTimeout(resolve, 15000)),
        ]),

    pendingComponent: () => <h1>Loading Route</h1>,
    // pendingComponent: () => <Loading size={192} />,
});
